import { render, staticRenderFns } from "./NotesTab3.vue?vue&type=template&id=8aa942dc&scoped=true"
import script from "./NotesTab3.vue?vue&type=script&lang=js"
export * from "./NotesTab3.vue?vue&type=script&lang=js"
import style0 from "./NotesTab3.vue?vue&type=style&index=0&id=8aa942dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa942dc",
  null
  
)

export default component.exports